import Vue from 'vue'
import Vuex from 'vuex'
import 'es6-promise/auto'
import axios from 'axios'

var API = "https://czf0q68nhd.execute-api.us-east-1.amazonaws.com/swab1/";

Vue.use(Vuex)

function sort_inks(inksd, colorsd) {
	let list = Object.keys(inksd);

	list.sort((na, nb) => {
		let a = inksd[na];
		let b = inksd[nb];
		let acolor = Array.isArray(a.color) ? a.color[0] : a.color;
		let bcolor = Array.isArray(b.color) ? b.color[0] : b.color;
		let aa = colorsd[acolor].index;
		let bb = colorsd[bcolor].index;
		if (aa < bb) {
			return -1;
		} else if (aa > bb) {
			return 1;
		}
		return 0;
	});

	return list;
}

function filter_inks(inks_all, inksd, colors, manufs, colorsd)
{
	let sel_colors = [];
	let sel_manufs = [];
	let a = [];

	for (let i in colors) {
		if (colors[i].selected) {
			sel_colors.push(colors[i].ident);
		}
	}
	for (let i in manufs) {
		if (manufs[i].selected) {
			sel_manufs.push(manufs[i].ident);
		}
	}

	/* inks_all já em ordem */
	for (let i in inks_all) {
		let kink = inks_all[i];
		let ink = inksd[kink];
		let ok = true;

		if (sel_colors.length !== 0) {
			if (!Array.isArray(ink.color)) {
				if (sel_colors.indexOf(ink.color) < 0) {
					ok = false;
				}
			} else {
				let any_ok = false;
				for (let c in ink.color) {
					let cl = ink.color[c];
					if (sel_colors.indexOf(cl) >= 0) {
						any_ok = true;
					}
				}
				if (! any_ok) {
					ok = false;
				}
			}
		}
 		if (sel_manufs.length !== 0) {
			if (sel_manufs.indexOf(ink.manufacturer) < 0) {
				ok = false;
			}
		}
		if (ok) {
			a.push(ink);
		}
	}

	return a;
}

function extract_manufacturers(inks)
{
	let ma = [];
	let md = {};

	for (let k in inks) {
		let name = inks[k].manufacturer;
		if (! md[name]) {
			ma.push({"index": name, "ident": name, "name": name});
			md[name] = ma[ma.length - 1];
			md[name].selected = false;
		}
	}
	ma.sort((a, b) => {
		if (a.index < b.index) {
			return -1;
		} else if (a.index > b.index) {
			return 1;
		}
		return 0;
	});
	return {"a": ma, "d": md};
}

function extract_colors(cdict)
{
	let ca = [];
	let cd = {};

	for (let k in cdict) {
		ca.push(cdict[k]);
		ca[ca.length - 1].selected = false;
		ca[ca.length - 1].ident = k;
		cd[k] = ca[ca.length - 1];
	}
	ca.sort((a, b) => {
		if (a.index < b.index) {
			return -1;
		} else if (a.index > b.index) {
			return 1;
		}
		return 0;
	});
	return {"a": ca, "d": cd};
}

const store = new Vuex.Store({
	state: {
		inksd: {},
		inks_all: [],
		inks_shown: [],
		colors: [],
		colorsd: {},
		manufacturers: [],
		manufacturersd: {},
		loading: false,
		loaded: false,
		load_error: false
	},
	getters: {
		color: (state) => (ident) => {
			return state.colorsd[ident];
		},
		next_ink: (state) => (ident, offset) => {
			let cur = state.inks_all.indexOf(ident);
			let next = (cur + offset + state.inks_all.length);
			next %= state.inks_all.length;
			return state.inks_all[next];
		},
		ink: (state) => (ident) => {
			return state.inksd[ident];
		},
	},
	mutations: {
		start_loading: (state) => {
			state.loading = true;
			state.loaded = false;
			state.load_error = false;
		},
		loaded: (state, data) => {
			state.loading = false;
			state.loaded = true;
			console.log("Inks loaded");
			state.inksd = data.inklist.inks;
			for (let kink in state.inksd) {
				state.inksd[kink].ident = kink;
			}
			let c = extract_colors(data.inklist.colors);
			state.colors = c.a;
			state.colorsd = c.d;
			console.log("Number of colors: " + state.colors.length);
			let m = extract_manufacturers(state.inksd);
			state.manufacturers = m.a;
			state.manufacturersd = m.d;
			console.log("Number of manufacturers: " + state.manufacturers.length);
			state.inks_all = sort_inks(state.inksd, state.colorsd);
			console.log("Number of inks: " + state.inks_all.length);
			state.inks_shown = filter_inks(state.inks_all, state.inksd,
					state.colors, state.manufacturers, state.colorsd);
		},
		notloaded: (state) => {
			state.loading = false;
			state.load_error = true;
		},
		toggle_color_in: (state, color_ident) => {
			console.log("Toggling color " + color_ident);
			state.colorsd[color_ident].selected = ! state.colorsd[color_ident].selected;
			state.inks_shown = filter_inks(state.inks_all, state.inksd,
				state.colors, state.manufacturers, state.colorsd);
		},
		toggle_manufacturer_in: (state, manuf_ident) => {
			console.log("Toggling manufacturer " + manuf_ident);
			state.manufacturersd[manuf_ident].selected =
				! state.manufacturersd[manuf_ident].selected;
			state.inks_shown = filter_inks(state.inks_all, state.inksd,
				state.colors, state.manufacturers, state.colorsd);
		},
		update_description_in: (state, data) => {
			console.log("Updating description of " + data.ink);
			if (state.inksd[data.ink].description === data.description) {
				console.log("Description not changed, doing nothing");
				return;
			}
			state.inksd[data.ink].new_description = data.description;
			// update locally to satisfy the local user
			state.inksd[data.ink].description = data.description;
			axios.put(API + "newdesc",
				{ink: data.ink, description: data.description})
			.then(response => {
				if (response.data.err) {
					console.log("Server response: " + response.data.err);
				} else {
					console.log("Server accepted new desc");
				}
        		})
			.catch((err) => {
				console.log("Server error");
				console.log(err);
			});
		},
		commit_description_in: (state, data) => {
			console.log("Committing description of " + data.ink);
			axios.post(API + "commitdesc",
				{ink: data.ink, password: data.password})
			.then(response => {
				if (response.data.err) {
					alert("Erro: " + response.data.err);
					return;
				} else {
					console.log("Server accepted commit");
					/* move new description locally */
					state.inksd[data.ink].description = 
						state.inksd[data.ink].new_description;
					state.inksd[data.ink].new_description = null;
				}
        		})
			.catch((err) => {
				console.log("Server error");
				console.log(err);
			});
		},
	},
	actions: {
		load: (context) => {
			if (context.state.loading) {
				console.log("Already loading inks");
				return;
			} else if (context.state.loaded) {
				console.log("Already loaded inks");
				return;
			}

			context.commit('start_loading');

			axios.get(API + "inklist")
			.then(response => {
				context.commit('loaded', {inklist: response.data});
        		})
			.catch((err) => {
				context.commit('notloaded');
				console.log("Could not load ink list");
				console.log(err);
			});
		},
		toggle_color: (context, color_ident) => {
			context.commit('toggle_color_in', color_ident);
		},
		toggle_manufacturer: (context, manuf_ident) => {
			context.commit('toggle_manufacturer_in', manuf_ident);
		},
		update_description: (context, data) => {
			context.commit('update_description_in', data);
		},
		commit_description: (context, data) => {
			context.commit('commit_description_in', data);
		},
	}
})

export default store;



// WEBPACK FOOTER //
// ./src/store/store.js